import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PromoBlock} from "./types/promo-block";
import {RouterLink} from "@angular/router";
import {environment} from "../../../../environments/environment";
import {SafePipe} from "../../../pipes/safe/safe.pipe";
import {WebpImageComponent} from "../../../components/webp-image/webp-image.component";

@Component({
  selector: 'app-widget-promo-block',
  standalone: true,
  imports: [CommonModule, RouterLink, SafePipe, WebpImageComponent],
  templateUrl: './promo-block.component.html',
  styleUrls: ['./promo-block.component.less']
})
export class PromoBlockComponent {
  @Input() widget!: PromoBlock;

  public getClasses(): string[] {
    let classes: string[] = []

    if (this.widget.data.image === null) {
      classes.push('promo-block--no-image');
    }

    return classes;
  }

  public getImageUrl(): string {
    return `${environment.cdn.url}/cdn/thumbnails/thumbnail/${this.widget.data.image}`;
  }

  protected isExternalLink(): boolean {
    return this.widget.data.buttonLink.startsWith('http');
  }
}
